import { Paper, Stack, Title, Text, Box, Divider } from '@mantine/core';
import type { OverviewMilestoneProgress } from '../../../../types';
import { MilestoneProgressBar } from './MilestoneProgressBar';
import { MilestoneItem } from './MilestoneItem';

interface MilestoneProgressProps {
  milestones: OverviewMilestoneProgress[];
}

export function MilestoneProgress({ milestones }: MilestoneProgressProps) {
  const sortedMilestones = [...milestones].sort(
    (a, b) => a.sortOrder - b.sortOrder
  );

  const completedCount = sortedMilestones.filter(
    m => m.status === 'completed'
  ).length;
  const totalCount = sortedMilestones.length;

  return (
    <Paper
      p="md"
      radius="md"
      bg="white"
      styles={{ root: { boxShadow: 'none' } }}
      style={{ border: '1px solid var(--mantine-color-gray-2)' }}
    >
      <Stack gap="md">
        <Box>
          <Title order={5}>Milestone Progress</Title>
          <Text size="sm" c="dimmed">
            {completedCount} of {totalCount} phases completed
          </Text>
        </Box>

        {/* Segmented progress bar */}
        <MilestoneProgressBar milestones={sortedMilestones} />

        <Divider />

        {/* Phase list */}
        {sortedMilestones.length === 0 ? (
          <Text size="sm" c="dimmed" ta="center" py="md">
            No phases configured for this cohort
          </Text>
        ) : (
          <Stack gap={0}>
            {sortedMilestones.map((milestone, index) => (
              <MilestoneItem
                key={milestone.phaseId}
                milestone={milestone}
                index={index}
              />
            ))}
          </Stack>
        )}
      </Stack>
    </Paper>
  );
}

export default MilestoneProgress;
